// Normalize notification keys (Postgres returns lowercase: forrole/fortid),
// then sort newest-first using a timestamp extracted from the id. The server
// uses ORDER BY id DESC which is unsafe because notification ids come in
// multiple shapes ("n<ts>", "notif_rent_<tid>_<ts>_<rand>", etc.) and
// lexicographic order on those strings doesn't match chronological order
// (e.g. "notif_..." > "n1..." because 'o' > '1').
//
// Strategy: pull every run of 10+ consecutive digits in the id and use the
// largest as the sort key — this captures Date.now()-style timestamps no
// matter where they appear in the id. IDs with no such run fall back to 0
// (sink to the bottom).
const idTime = (id) => {
    const matches = (id || "").match(/\d{10,}/g);
    if (!matches) return 0;
    let max = 0;
    for (const m of matches) {
        const v = Number(m);
        if (v > max) max = v;
    }
    return max;
};

export const normNotifs = (arr) => (arr || [])
    .map(n => ({
        id: n.id, forRole: n.forRole || n.forrole, forTid: n.forTid || n.fortid,
        msg: n.msg, type: n.type, time: n.time, read: !!n.read
    }))
    .sort((a, b) => idTime(b.id) - idTime(a.id));
